<form #actualForm="ngForm" class="dt-form" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
  <mat-form-field>
    <mat-label i18n>E-Mail</mat-label>
    <input matInput type="email" formControlName="email" required />

    @if (emailForm.controls.email.hasError('required') || emailForm.controls.email.hasError('email')) {
      <mat-error i18n>Bitte gib eine gültige E-Mail-Adresse ein</mat-error>
    }
  </mat-form-field>

  @if (emailForm.hasError('server-error')) {
    <mat-error i18n>Bei der Übertragung der Daten ist ein Fehler aufgetreten</mat-error>
  }

  <button
    mat-raised-button
    [dtOverlayProgress]="emailForm.disabled"
    type="submit"
    color="accent"
    [disabled]="emailForm.controls.email.value === originalEmail || emailForm.disabled || (!emailForm.valid && !actualForm.submitted)"
    i18n
    >Speichern</button
  >
</form>
